module.exports = __webpack_public_path__ + "static/img/09.6aa47fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/03/09.jpg
// module id = pVkY
// module chunks = 0